<section class="twigh-showcase">
  <div class="twigh-shell">
    <div class="twigh-heading reveal">
      <p class="section-label twigh-label">An Arrival Story Before The Layers Unfold</p>
      <h2 class="twigh-title">CRAFTED FOR EXTRA ORDINARY LIVING</h2>
      <img src="/backgrounds/twig.webp" alt="" class="twigh-mark" aria-hidden="true" />
      <p class="twigh-copy">
        Before the amenity collection rises skyward, the ground plane sets the tone with retail energy,
      dining, a composed entrance, and a lobby that feels more like a private salon.
      </p>
    </div>
  </div>

  <div class="twigh-slider-wrap">
    <swiper-container
      #swiperEl
      class="twigh-slider reveal reveal-delay-1"
      slides-per-view="1"
      space-between="0"
      centered-slides="true"
      rewind="true"
      grab-cursor="true"
      speed="900"
      [pagination]="pagination"
      [autoplay]="autoplay"
      [breakpoints]="breakpoints"
    >
      @for (slide of slides; track slide.title; let i = $index) {
        <swiper-slide>
          <article class="twigh-card">
            <div class="twigh-media">
              <button
                type="button"
                class="twigh-media-hit"
                (click)="openAt(i, $event)"
                [attr.aria-label]="'View ' + slide.title + ' fullscreen'"
              ></button>
              <img [src]="slide.image" [alt]="slide.alt" class="twigh-image" />
              <button
                type="button"
                class="twigh-zoom-btn"
                (click)="openAt(i, $event)"
                [attr.aria-label]="'View ' + slide.title + ' fullscreen'"
              >
                <svg width="22" height="22" viewBox="0 0 22 22" fill="none" aria-hidden="true">
                  <circle cx="9" cy="9" r="6.5" stroke="currentColor" stroke-width="1.6"/>
                  <path d="M14 14l4 4" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>
                  <path d="M6.5 9H11.5M9 6.5V11.5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>
                </svg>
              </button>
            </div>
            <div class="twigh-meta">
              <div class="twigh-step">
                <span class="twigh-step-line"></span>
              </div>
              <div class="twigh-text">
                <h3>{{ slide.title }}</h3>
                <p>{{ slide.subtitle }}</p>
              </div>
            </div>
          </article>
        </swiper-slide>
      }
    </swiper-container>

    <div class="twigh-nav">
      <button class="twigh-nav-btn twigh-nav-prev" (click)="prevSlide()" aria-label="Previous slide">
        <div class="twigh-nav-ring"></div>
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" aria-hidden="true">
          <path d="M11 14L6 9l5-5" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>
      <button class="twigh-nav-btn twigh-nav-next" (click)="nextSlide()" aria-label="Next slide">
        <div class="twigh-nav-ring"></div>
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" aria-hidden="true">
          <path d="M7 4l5 5-5 5" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>
    </div>
  </div>
</section>

<!-- lightGallery mount point (hidden) -->
<div #lgContainer style="display:none"></div>
